<template>
  <div>
    <div class="home">
      <div class="home-banner">
        <img src="@/assets/img/index/banner1.png">
        <div class="content">
          智慧会展创造者、先行者及领导者
        </div>
      </div>
      <div class="card-row">
        <div class="card">
          <img src="@/assets/img/index/areas1.png">
          <div class="newNavHead"></div>
          <div class="mask"></div>
          <div class="newNavContent">
            <p>平台服务</p>
            <router-link to="/service#platform">
              <span>查看详情</span>
              <span class="arrowDetail"></span>
            </router-link>
          </div>
        </div>
        <div class="card">
          <img src="@/assets/img/index/areas2.png">
          <div class="newNavHead"></div>
          <div class="mask"></div>
          <div class="newNavContent">
            <p>人才网络</p>
            <router-link to="/service#network">
              <span>查看详情</span>
              <span class="arrowDetail"></span>
            </router-link>
          </div>
        </div>
        <div class="card">
          <img src="@/assets/img/index/areas3.png">
          <div class="newNavHead"></div>
          <div class="mask"></div>
          <div class="newNavContent">
            <p>智能会议</p>
            <router-link to="/service#meeting">
              <span>查看详情</span>
              <span class="arrowDetail"></span>
            </router-link>
          </div>
        </div>
      </div>
      <div>
        <div style="text-align: center;">
          <div class="title">
            <div class="line1"></div>
            <div class="letter">A</div>
            <div class="txt">
              <div>应用介绍</div>
              <div class="sub-title">Application Introduction</div>
            </div>
            <div class="line2"></div>
          </div>
        </div>
        <!-- 应用介绍 -->
        <div class="app-intro">
          <div class="container">
            <!-- <h2>亿会通应用介绍</h2> -->
            <div class="intro-content">
              <div class="intro-text">
                <p>亿会通是一款专为企业打造的智能会议管理平台，致力于为企业提供全流程、一站式的会议管理解决方案。通过数字化技术，亿会通帮助企业简化会议流程、降低管理成本、提高会议效率。</p>
                <p>平台集成了会议预约、场地管理、参会人员管理、物料准备、餐饮安排、交通调度、费用结算等全方位功能，实现了会议管理的智能化和自动化。</p>
                <p>亿会通凭借先进的技术架构和优质的服务，已经为医药、金融、科技等多个行业的知名企业提供了专业的会议管理服务，获得了客户的一致好评。</p>
              </div>
              <div class="intro-features">
                <h3>核心优势</h3>
                <ul>
                  <li><i class="icon-check"></i> 全流程管理：从会议发起至结束，实现一站式管理</li>
                  <li><i class="icon-check"></i> 智能推荐：基于历史数据和偏好，智能推荐会议方案</li>
                  <li><i class="icon-check"></i> 数据可视化：会议数据实时统计，生成可视化报表</li>
                  <li><i class="icon-check"></i> 安全可靠：采用高级加密技术，保障数据安全</li>
                  <li><i class="icon-check"></i> 灵活定制：根据企业需求，提供个性化解决方案</li>
                  <li><i class="icon-check"></i> 24/7服务：专业团队全天候提供技术支持</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div style="text-align: center;">
          <div class="title">
            <div class="line1"></div>
            <div class="letter">S</div>
            <div class="txt">
              <div>我们的服务</div>
              <div class="sub-title">Service Introduction</div>
            </div>
            <div class="line2"></div>
          </div>
        </div>
         <!-- 服务信息 -->
    <div class="services-info">
      <div class="container">
        <!-- <h2>我们的服务</h2> -->
        <div class="services-grid">
          <div class="service-item">
            <div class="service-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </div>
            <h3>会议场地预订</h3>
            <p>覆盖全国100+城市的优质会议场地资源，提供多样化的场地选择，满足不同规模和类型的会议需求。</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <h3>参会人员管理</h3>
            <p>智能化的参会人员管理系统，支持在线报名、签到、身份验证等功能，提高参会体验和管理效率。</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
            <h3>会议物料准备</h3>
            <p>专业的会议物料设计和制作团队，提供邀请函、议程、背景板、横幅等会议所需物料的一站式服务。</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 10h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8z"></path>
                <path d="M12 2v8"></path>
              </svg>
            </div>
            <h3>餐饮住宿安排</h3>
            <p>根据会议需求，提供个性化的餐饮和住宿解决方案，确保参会人员的饮食和住宿舒适。</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                <line x1="6" y1="1" x2="6" y2="4"></line>
                <line x1="10" y1="1" x2="10" y2="4"></line>
                <line x1="14" y1="1" x2="14" y2="4"></line>
              </svg>
            </div>
            <h3>交通调度服务</h3>
            <p>整合滴滴、神州等多家出行平台资源，提供便捷的交通调度服务，确保参会人员的出行顺畅。</p>
          </div>
          <div class="service-item">
            <div class="service-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
              </svg>
            </div>
            <h3>费用结算管理</h3>
            <p>智能化的费用结算系统，自动生成费用报表，支持多种支付方式，简化费用管理流程。</p>
          </div>
        </div>
      </div>
    </div>
      </div>
      <div>
        <div style="text-align: center;">
          <div class="title">
            <div class="line1"></div>
            <div class="letter">S</div>
            <div class="txt">
              <div>服务网络</div>
              <div class="sub-title">ervice Network</div>
            </div>
            <div class="line2"></div>
          </div>
        </div>
        <div class="city-title">
          <span>300+</span>国内城市，
          <span>32</span>个国际热点国家与地区服务覆盖
        </div>
        <div class="city-title">
          <span>4</span>个中心（北京、上海、成都、广州），
          <span>10000+</span>本地化人才网络成员
        </div>
        <Map />
      </div>
      <div>
        <div style="text-align: center;">
          <div class="title">
            <div class="line1"></div>
            <div class="letter">S</div>
            <div class="txt">
              <div>服务客户</div>
              <div class="sub-title">ervice customer</div>
            </div>
            <div class="line2"></div>
          </div>
        </div>
        <div class="service">
          <swiper :options="serviceSwiper" ref="serviceSwiper">
            <swiper-slide v-for="(slide, index) in serviceSwiperChildren" :key="index">
              <img v-for="item in slide" :key="item" :src="require(`@/assets/img/index/customer/${item}.png`)">
            </swiper-slide>
            <div class="swiper-button-prev swiper-button-prevs" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-nexts" slot="button-next"></div>
          </swiper>
        </div>
      </div>
      <div>
        <div style="text-align: center;">
          <div class="title">
            <div class="line1"></div>
            <div class="letter">P</div>
            <div class="txt">
              <div>合作伙伴</div>
              <div class="sub-title">artner</div>
            </div>
            <div class="line2"></div>
          </div>
        </div>
        <div class="partner">
          <swiper :options="partnerSwiper" ref="partnerSwiper">
            <swiper-slide v-for="(slide, index) in partnerSwiperChildren" :key="index">
              <div>
                <img v-for="item in slide" :key="item" :src="require(`@/assets/img/index/partner/${item}.png`)">
              </div>
            </swiper-slide>
            <div class="swiper-button-prev swiper-button-prev-old" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-next-old" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer";
import Map from "@/views/Home/map1.vue";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "home",
  components: {
    Footer,
    swiper,
    swiperSlide,
    Map
  },
  data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      serviceSwiper: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-nexts",
          prevEl: ".swiper-button-prevs"
        }
      },
      partnerSwiper: {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next-old",
          prevEl: ".swiper-button-prev-old"
        }
      },
      serviceSwiperChildren: [],
      partnerSwiperChildren: [],
      honorSwiperChildren: [
        "香港会展局佳绩奖",
        "最具创新力PCO",
        "MICE三亚最佳贡献奖",
        "2016 商务会奖旅游 金椅子奖",
        "南京会奖旅游顾问单位",
        "2016年度会奖旅游金椅子奖",
        "2011年度BestPCO",
        "2018 商务会奖旅游 金椅子奖",
        "国家旅业榜",
        "奇迹奖 最佳Event",
        "绿色会展联盟会员",
        "中国会议产业大会华表奖",
        "MICE亚太协会会员",
        "中国最具竞争力品牌",
        "云南MICE风云榜TOP10",
        "奇迹奖 最佳PCO",
        "国家高新企业证书",
        "文创企业信促会证书",
        "中关村高新企业证书"
      ],
      screenWidth: document.body.clientWidth,
      timer: false
    };
  },
  methods: {
    imgPush(max, imgNum, number) {
      let arr = [];
      let item = [];
      for (let i = 1; i < max + 1; i++) {
        if (i % imgNum) {
          if (i > number) {
            item.push(i - number);
          } else item.push(i);
        } else {
          if (i > number) {
            item.push(i - number);
          } else item.push(i);
          arr.push(item);
          item = [];
        }
      }
      return arr;
    },
    initData() {
      let screenW = document.body.clientWidth;
      if (screenW <= 997) {
        var imgNum1 = 20;
        var max1 = 80;
        var imgNum2 = 15;
        var max2 = 45;
      } else {
        var imgNum1 = 32;
        var max1 = 96;
        var imgNum2 = 24;
        var max2 = 48;
      }
      this.serviceSwiperChildren = this.imgPush(max1, imgNum1, 72);
      this.partnerSwiperChildren = this.imgPush(max2, imgNum2, 42);
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  watch: {
    screenWidth(val) {
      let that = this;
      this.screenWidth = val;
      that.$refs.serviceSwiper.swiper.destroy(); //先销毁
      that.$refs.serviceSwiper.mountInstance(); //后在加载
      that.$refs.partnerSwiper.swiper.destroy(); //先销毁
      that.$refs.partnerSwiper.mountInstance(); //后在加载
      that.initData();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../less/home.less";

/* 应用介绍 */
.app-intro {
  padding: 60px 0;
  background: #f8f9fa;

  h2 {
    text-align: center;
    font-size: 32px;
    margin-bottom: 40px;
    color: #333;
  }

  .intro-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;

    .intro-text {
      p {
        margin-bottom: 16px;
        line-height: 26px;
        color: #666;
        font-size: 16px;
      }
    }

    .intro-features {
      h3 {
        font-size: 20px;
        margin-bottom: 20px;
        color: #333;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          padding: 10px 0;
          padding-left: 30px;
          position: relative;
          color: #666;
          font-size: 16px;

          &::before {
            content: '✓';
            position: absolute;
            left: 0;
            color: #39C5D5;
            font-weight: bold;
            font-size: 18px;
          }
        }
      }
    }
  }
}

/* 服务信息 */
.services-info {
  padding: 60px 0;

  h2 {
    text-align: center;
    font-size: 32px;
    margin-bottom: 40px;
    color: #333;
  }

  .services-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
  }

  .service-item {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    text-align: center;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    }
  }

  .service-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 20px;
    background: linear-gradient(135deg, #39C5D5 0%, #2B8BC3 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .service-item h3 {
    font-size: 20px;
    margin-bottom: 16px;
    color: #333;
  }

  .service-item p {
    line-height: 24px;
    color: #666;
    font-size: 15px;
  }
}
</style>
